import React from 'react'
import { SmileySad } from '@phosphor-icons/react'
import { Icon } from '@shopflo/ui'
import { useLocale } from 'src/lib/hooks/useLocal'

interface DrawerErrorFallbackProps {
  title?: string
  description?: string
  onRetry?: () => void
}

const DrawerErrorFallback: React.FC<DrawerErrorFallbackProps> = ({ title, description, onRetry }) => {
  const { t } = useLocale()
  const resolvedTitle = title ?? t('drawer_error_title')
  const resolvedDescription = description ?? t('drawer_error_description')

  return (
    <div className='flex h-full flex-col items-center justify-center gap-3 px-8 py-12'>
      <Icon IconComponent={SmileySad} size='xl' className='text-zinc-300' iconProps={{ weight: 'duotone' }} />
      <div className='flex flex-col items-center gap-1'>
        <span className='text-text-sm-semibold text-zinc-600'>{resolvedTitle}</span>
        <span className='text-center text-text-xs-regular text-zinc-400'>{resolvedDescription}</span>
      </div>
      {onRetry && (
        <button
          type='button'
          className='mt-1 rounded-lg border border-zinc-200 bg-white px-3 py-1.5 text-text-xs-medium text-zinc-600 shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)] hover:bg-zinc-50 cursor-pointer'
          onClick={onRetry}
        >
          {t('drawer_error_retry')}
        </button>
      )}
    </div>
  )
}

export default DrawerErrorFallback
